import(/* webpackMode: "eager" */ "/opt/build/repo/app/auth/forgot/page.tsx");
